import "@esri/calcite-components/components/calcite-block";
import "@esri/calcite-components/components/calcite-panel";
import "@esri/calcite-components/components/calcite-notice";
import "@esri/calcite-components/components/calcite-link";
import "@esri/calcite-components/components/calcite-list";
import Camera from "@arcgis/core/Camera.js";
import { useEffect, useState } from "react";
import texts from "../../../assets/texts/texts.js";

import { sharedQueue } from "./layerlist/Queue.js";
import Point from "@arcgis/core/geometry/Point.js";

let layerListArray = [];
let animate;
let abort;
function ProjektList({ projectListInput }) {
  const [layers, setLayers] = useState([]);
  useEffect(() => {
    if (projectListInput) {
      const date = new Date();
      projectListInput.id = date.getTime();
      //layerListArray.push(layerListInput);

      (layerListArray) => [...layerListArray, projectListInput];
    }
    setLayers(sharedQueue.data);
  });

  const removeValue = (value) => {
    const scenView = document.querySelector("#viewDiv");
    const view = scenView.view;

    view.graphics.remove(value.mesh);

    setLayers((prev) => prev.filter((item) => item.id !== value.id));
    sharedQueue.dequeue(
      sharedQueue.data.findIndex((element) => element.id === value.id),
    );
  };

  return (
    <>
      <calcite-panel
        menu-placement="bottom-end"
        scale="l"
        class="esri-component"
      >
        <calcite-list
          className="layerList__calcite"
          selection-mode="multiple"
          label="Park features"
          drag-enabled
        >
          {layers &&
            layers.map((item, index) => (
              <calcite-list-item
                key={item.id}
                label={item.name}
                value="hiking-trails"
                selected
                onClick={(e) => {
                  if (e.target.selected !== undefined) {
                    item.mesh.visible = e.target.selected;
                    animate = false;
                  }
                }}
              >
                <calcite-action
                  onClick={() => {
                    zoomToLayer(item);
                  }}
                  slot="actions-end"
                  appearance="solid"
                  scale="m"
                  icon="zoom-to-object"
                  calcite-hydrated=""
                ></calcite-action>
                <calcite-action
                  onClick={() => removeValue(item)}
                  slot="actions-end"
                  class="remove__projects"
                  appearance="solid"
                  scale="m"
                  icon="trash"
                  calcite-hydrated=""
                ></calcite-action>
              </calcite-list-item>
            ))}
        </calcite-list>
        <calcite-notice
          id="projektyNotice"
          className="margin_top"
          open
          icon="information"
        >
          <div slot="message">
            {layers.length > 0
              ? texts.widgets.uploadmodel.projekts.projectInfo + " "
              : texts.widgets.uploadmodel.projekts.startInfo + " "}
            <calcite-link
              target="_blank"
              slot="link"
              href={texts.widgets.uploadmodel.projekts.descriptionsURL}
            >
              {texts.description +
                ": " +
                texts.widgets.uploadmodel.projekts.title}
            </calcite-link>
          </div>
        </calcite-notice>
      </calcite-panel>
    </>
  );
}

export default ProjektList;

const zoomToLayer = (value) => {
  if (animate) {
    animate = false;
  } else {
    value.mesh.visible = true;

    animate = true;
    abort = false;
  }

  const scenView = document.querySelector("#viewDiv");
  const view = scenView.view;

  view
    .goTo({
      target: value.mesh.geometry,
      tilt: 45,
    })
    .then(() => {
      // Rotation araound init center point
      setTimeout(() => {
        let center = null;
        const rotate = () => {
          if (!view.interacting && !abort && animate) {
            center = center || view.center;

            view.goTo(
              {
                heading: view.camera.heading + 0.2,

                center,
              },
              { animate: false },
            );

            requestAnimationFrame(rotate);
          } else {
            abort = false;
            center = null;
          }
        };

        rotate();
      }, 100);
    })
    .catch((error) => {
      console.log(error);
      abort = false;
    });
};
